export default "__VITE_ASSET__DMOdV0dP__"